import React, { useState } from "react";
import {
  List,
  Box,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import PropTypes from "prop-types";
import CustomMenu from "./CustomMenu";
import arrowRightIcon from "../../../../../../../images/icon_arrow_right/icon_arrow_right_24x24.svg";
import arrowDownIcon from "../../../../../../../images/icon_arrow_down_light/icon_arrow_down_light_24x24.svg";
import menuIcon from "../../../../../../../images/icon_hamburger_menu/icon_hamburger_menu.svg";
import menuFocusedIcon from "../../../../../../../images/icon_hamburger_menu/icon_hamburger_menu_focus.svg";

const NestedList = ({ items }) => {
  const [open, setOpen] = useState([]);

  const handleClick = (id) => {
    setOpen((prev) =>
      prev.includes(id) ? prev.filter((openId) => openId !== id) : [...prev, id]
    );
  };

  return (
    <List sx={{ width: "100%", bgcolor: "transparent" }}>
      {items.map(({ id, name, subItems, mainEvnMenuItems }) => (
        <Box sx={{ marginBottom: "8px" }} key={id}>
          <Box
            sx={{
              display: "flex",
              backgroundColor: open.includes(id) && "#3BBFF01A",
              marginBottom: "16px",
              borderRadius: "8px",
            }}
          >
            <ListItemButton
              onClick={() => handleClick(id)}
              sx={{
                padding: "0 !important",
                maxWidth: "159px",
                display: "flex",
                alignItems: "start",
              }}
            >
              <img
                src={open.includes(id) ? arrowDownIcon : arrowRightIcon}
                alt="arrowIcon"
                style={{ marginRight: "4px", padding: "4px 0" }}
              />
              <ListItemText
                primary={name}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  marginRight: "8px !important",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  color: open.includes(id) ? "#0EA2E9" : "white",
                }}
              />
            </ListItemButton>
            <CustomMenu
              icon={open.includes(id) ? menuFocusedIcon : menuIcon}
              menuItems={mainEvnMenuItems}
            />
          </Box>
          {subItems.map((subItem) => (
            <Collapse
              in={open.includes(id)}
              timeout="auto"
              unmountOnExit
              key={subItem.id}
            >
              <List component="div" disablePadding>
                <Box sx={{ display: "flex" }}>
                  <ListItemButton
                    sx={{ padding: "0 !important", marginBottom: "16px" }}
                  >
                    <ListItemText
                      primary={subItem.name}
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                        marginLeft: "28px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                    />
                  </ListItemButton>
                  {subItem.subEvnMenuItems.length > 0 && (
                    <CustomMenu
                      icon={menuIcon}
                      menuItems={subItem.subEvnMenuItems}
                    />
                  )}
                </Box>
              </List>
            </Collapse>
          ))}
        </Box>
      ))}
    </List>
  );
};

NestedList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          subEvnMenuItems: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              func: PropTypes.func.isRequired,
            })
          ).isRequired,
        })
      ).isRequired,
      mainEvnMenuItems: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          func: PropTypes.func.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default React.memo(NestedList);
